export const isNewItem = (item, key) => {
  if (!item) return false

  const lastSeenStr = localStorage.getItem(`last_seen_${key}`)

  let createdAtRaw =
    item.created_at ||
    item.updated_at ||
    item.createdAt ||
    item.created ||
    item.date ||
    null

  if (key === 'whatsnew' && item.released_at) {
    createdAtRaw = item.released_at
  }

  const createdAt = createdAtRaw ? new Date(createdAtRaw) : new Date(parseInt(item.id) || Date.now())
  if (Number.isNaN(createdAt.getTime())) return false

  if (!lastSeenStr) return true

  const lastSeen = new Date(lastSeenStr)
  if (Number.isNaN(lastSeen.getTime())) return true

  return createdAt > lastSeen
}
